/**
 * Created by prog2 on 25/10/2018.
 */

import castellano from './castellano';
import english from './english';
import deutsch from './deutsch';
import valencia from './valencia';
import français from './français';
import italiano from './italiano';
import nederlands from './nederlands';

const messages = {
    Castellano: castellano,
    English: english,
    Deutsch: deutsch,
    Valencià: valencia,
    Français: français,
    Italiano: italiano,
    Nederlands: nederlands,
}

export default messages;



// WEBPACK FOOTER //
// ./src/data/i18n/i18n.js